import { apiCall, brokerapiCall } from './ApiInstance';
import routes from '../../constants/routes.json'
import { Buffer } from 'buffer';


function login(values) {
  const route = routes['login'];
  return apiCall(route.route, route.method, {
    data: {
      cloud_username: values.email,
      cloud_password: Buffer.from(values.password).toString('base64')
    },
  });
}
function myNumber(values) {
  const route = routes['myNumber'];

  return brokerapiCall(route.route, route.method, {
    data: {
      tenant_id: values,
    },
  });
}

function resellerLogin(values) {

  const route = routes['resellerLogin'];
  return apiCall(route.route, route.method, {
    data: {
      email: values.email,
      password: values.password
    },
  });
}

function createUserAsLocation(values) {
  const route = routes['createUserAsLocation'];
  return apiCall(route.route, route.method, {
    data: {
      tenantId: values.tenantId,
      domain: values.domain,
      userInfo: {
        extension: values.extension,
        language: values.language || "en",
        locationName: values.locationName
      }
    },
  });
}

function updateUserAsLocation(values) {
  const route = routes['updateUserAsLocation'];
  return apiCall(route.route, route.method, {
    data: {
      tenantId: values.tenantId,
      extension: values.extension,
      userInfo: {
        language: values.language || "en",
        locationName: values.locationName
      }
    },
  });
}

function deleteUserAsLocation(values) {
  const route = routes['deleteUserAsLocation'];
  return apiCall(route.route, route.method, {
    data: {
      extension: values.extension,
      tenantId: values.tenantId
    },
  });
}

export {
  login,
  myNumber,
  resellerLogin,
  createUserAsLocation,
  updateUserAsLocation,
  deleteUserAsLocation
};
